<template lang="pug">
  v-container.px-10(fluid)
    v-row
      v-col(cols="3")
        v-text-field(
          :value="instance.name",
          @input="$store.commit(setInstancePathAction, { path: path + '.name', value: $event })"
          :label="$t('Task.name')",
          :error-messages="errors['task.name']",
        )
      v-col(cols="6")
        v-text-field(
          :value="instance.definition",
          @input="$store.commit(setInstancePathAction, { path: path + '.definition', value: $event })"
          :label="$t('Task.definition')",
          :error-messages="errors['task.definition']",
        )
      v-col(cols="2")
        v-select(
          :value="instance.type",
          @input="$store.commit(setInstancePathAction, { path: path + '.type', value: $event })"
          :items= "types",
          :label="$t('Task.type')",
          :error-messages="errors['task.type']",
        )
      v-col(cols="1")
        v-select(
          :value="instance.priority",
          @input="$store.commit(setInstancePathAction, { path: path + '.priority', value: $event })"
          :items= "priorities",
          :label="$t('Task.priority')",
          :error-messages="errors['task.priority']",
        )
    v-row
      v-col(cols="6")
        v-text-field(
          :value="instance.responsibleExpression",
          @input="$store.commit(setInstancePathAction, { path: path + '.responsibleExpression', value: $event })"
          :label="$t('Task.responsibleExpression')",
          :error-messages="errors['task.responsibleExpression']",
        )
      v-col(cols="6")
        v-text-field(
          :value="instance.deadLineExpression",
          @input="$store.commit(setInstancePathAction, { path: path + '.deadLineExpression', value: $event })"
          :label="$t('Task.deadLineExpression')",
          :error-messages="errors['task.deadLineExpression']",
        )
    v-row
      v-col
        v-switch(
          :input-value="instance.computedResponsibility",
          @change="$store.commit(setInstancePathAction, { path: path + '.computedResponsibility', value: $event })"
          :label="$t('Task.computedResponsibility')",
          :error-messages="errors['task.computedResponsibility']",
        )
      v-col
        app-datetime-picker(
          :value="instance.createdAt",
          :label="$t('Task.createdAt')",
          disabled,
        )
      v-col
        app-datetime-picker(
          :value="instance.modifiedAt",
          :label="$t('Task.modifiedAt')",
          disabled,
        )
      v-col
        v-text-field(
          :label="$t('Task.userFullName')",
          :value="(instance.user || {}).fullName"
          :error-messages="errors['task.user']",
          :error="!!errors['task.user']",
          disabled,
        )
</template>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
  mixins: [EntityMixin],
  props: ['path', 'entity'],
  name: 'Task',
  data: function () {
    return {
      priorities: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ],
      types: ['Call', 'Email' , 'ASN', 'CONF', 'TIE', 'Manual', 'QUOTE'],
    }
  },
  methods: {
    initInstance () {
      return {
        ...this.instance,
        user: this.instance && this.instance.id
          ? this.instance.user
          : this.$store.state.user.user
      }
    }
  },
  computed: {
    errors(){
     return this.$store.state.errors;
    }
  },
  async created() {
    this.instance = this.initInstance();
  }
}
</script>
